// extracted by mini-css-extract-plugin
export default {"modalHeader":"CustomDeleteModal_modalHeader__I2u82"};